module.exports = __webpack_public_path__ + "static/media/disagree@3x.c568a190.png";